import { useState } from "react";
import { useParams } from "react-router-dom";
import useAuth from "../../../../hooks/useAuth";
import useQueryAuth from "../../../../hooks/useQueryAuth";

import { getFiltersObject } from "./filtersConfigV2";
import Mnemonic from "../../../../Mnemonics.json";

import {
	GET_ALL_PROJECTS_DROPDOWN,
	GET_CUSTOMERS,
} from "../../../../graphql/project";
import { GET_ALL_EMPLOYEES_DROPDOWN } from "../../../../graphql/employee";
import { GET_ALL_TASK_STATUSES } from "../../../../graphql/taskStatus";
import { GET_ALL_TEAMS } from "../../../../graphql/team";
import { GET_ALL_AREAS } from "../../../../graphql/areas";
import { GET_ALL_PARENT_TASKS } from "../../../../graphql/task";

const prioritiesList = [
	{ label: Mnemonic.Priority.Low, value: Mnemonic.Priority.Low },
	{ label: Mnemonic.Priority.Medium, value: Mnemonic.Priority.Medium },
	{ label: Mnemonic.Priority.High, value: Mnemonic.Priority.High },
];
export function useTaskFilters({
	fromProject = false,
	fromTicket = false,
	fromTenant = false,
}) {
	const { storeUserGuid, storeUserTenant, userRoles } = useAuth();
	const { isAdmin } = userRoles;
	const params = useParams();
	const [fetchAreas, setFetchAreas] = useState(false);

	const [fetchCustomers, setFetchCustomers] = useState(false);
	const [fetchTeams, setFetchTeams] = useState(false);
	const [fetchEmployees, setFetchEmployees] = useState(false);
	const [fetchProjects, setFetchProjects] = useState(false);
	const [fetchTaskStatuses, setFetchTaskStatuses] = useState(true);
	// local UI state
	const [filterState, setFilterState] = useState([]);
	const [defaultFilters, setDefaultFilters] = useState({
		billable: true,
		nonBillable: true,
		unassignedTasks: false,
	});
	const [selectedProject, setSelectedProject] = useState(null);
	// fetch dropdowns and lists
	const { data: projectsData, loading: projectLoading } = useQueryAuth(
		GET_ALL_PROJECTS_DROPDOWN,
		"GetAllProjects",
		{
			variables: {
				model: {
					enableFilters: false,
					tenantID: fromTenant ? null : storeUserTenant,
					userID: storeUserGuid,
				},
			},
			skip: !fetchProjects,
			isWait: fetchProjects,
		}
	);
	const { data: employeesData, loading: employeeLoading } = useQueryAuth(
		GET_ALL_EMPLOYEES_DROPDOWN,
		"GetCompanyUsersList",
		{
			variables: {
				model: {
					enableFilters: false,
					userID: storeUserGuid,
					tenantID: fromTenant ? null : storeUserTenant,
					showAll: true,
				},
			},
			skip: !fetchEmployees,
			isWait: fetchEmployees,
		}
	);
	const { data: statusData, loading: statusLoading } = useQueryAuth(
		GET_ALL_TASK_STATUSES,
		"GetTaskStatuses",
		{
			variables: {
				model: {
					enableFilters: false,
					tenantID: fromTenant ? null : storeUserTenant,
				},
			},
			skip: !fetchTaskStatuses,
			isWait: fetchTaskStatuses,
		}
	);
	const { data: teamsData, loading: teamsLoading } = useQueryAuth(
		GET_ALL_TEAMS,
		"GetTeamsList",
		{
			variables: { model: { tenantGuid: storeUserTenant, userID: null } },
			skip: !fetchTeams,
			isWait: fetchTeams,
		}
	);
	const { data: areaData, loading: areaLoading } = useQueryAuth(
		GET_ALL_AREAS,
		"GetAreasList",
		{
			variables: {
				model: {
					enableFilters: false,
					projectGuid: params.pID || selectedProject?.projectGuid,
				},
			},
			skip: !(fetchAreas && (selectedProject || params.pID)),
			isWait: fetchAreas && (selectedProject || params.pID),
		}
	);
	const { data: parentTaskData, loading: taskLoading } = useQueryAuth(
		GET_ALL_PARENT_TASKS,
		"GetTasks",
		{
			variables: {
				model: {
					tenantID: storeUserTenant,
					enableFilters: false,
					onGoingTasks: true,
					userID: storeUserGuid,
					projectID: params.pID || selectedProject?.projectGuid,
				},
			},
		}
	);
	const { data: customersData, loading: customerLoading } = useQueryAuth(
		GET_CUSTOMERS,
		"GetAllCustomers",
		{
			variables: { model: { enableFilters: false, userID: storeUserGuid } },
			skip: !fetchCustomers,
			isWait: fetchCustomers,
		}
	);

	// build filter object
	const filtersObject = getFiltersObject(
		fromProject,
		projectsData?.GetAllProjects?.projectsList?.projectViews || [],
		employeesData?.GetCompanyUsersList?.usersList?.employees || [],
		statusData?.GetTaskStatuses?.tasksStatus || [],
		teamsData?.GetTeamsList?.teamsList?.teams || [],
		teamsLoading,
		projectLoading,
		employeeLoading,
		statusLoading,
		isAdmin,
		false,
		defaultFilters,
		filterState,
		areaData?.GetAreasList?.areasList?.areas || [],
		areaLoading,
		parentTaskData?.GetTasks?.tasks || [],
		taskLoading,
		setFetchProjects,
		setFetchTeams,
		setFetchAreas,
		setSelectedProject,
		selectedProject,
		prioritiesList,
		setFetchCustomers,
		customersData?.GetAllCustomers?.customers || [],
		customerLoading,
		setFetchEmployees,
		setFetchTaskStatuses
	);

	return {
		filtersObject,
		filterState,
		setFilterState,
		defaultFilters,
		setDefaultFilters,
		selectedProject,
		setSelectedProject,
		statusData,
		teamsData,
		employeesData,
		areaData,
		projectsData,
		parentTaskData,
		// expose other dropdowns/data as needed
	};
}
